
const Ratings = () => {
    return null;
}

export default Ratings;
